export default __webpack_public_path__ + "static/gtech-e5b6fa49470a518f178b4ab9f239d2a8.png";